module.exports = __webpack_public_path__ + "img/life-page4-img-2.8c730d3d.jpg";